import { Pipe, PipeTransform } from '@angular/core';
import { last } from 'lodash';

@Pipe({
    name: 'lastFromArray',
    standalone: false
})
export class LastArrayElementPipe implements PipeTransform {
  transform<ArrayElementType>(value: ArrayElementType[]): ArrayElementType {
    return last(value);
  }
}
